import { useMemo, useState } from "react";
import { FiSliders } from "react-icons/fi";
import { useFetchVendorsQuery } from "../../../features/admin/vendor/vendorApi";
import TenantSidebarEditor from "./TenantSidebarEditor";
import {
  Page,
  PageHeader,
  SearchInput,
  Table,
  THead,
  Th,
  Td,
  EmptyRow,
  Button,
} from "../../../components/ui";

const token = () => sessionStorage.getItem("access_token");

const AllTenantSidebar = () => {
  const [search, setSearch] = useState("");
  const [editor, setEditor] = useState(null); // { tenant_id, tenant_name }

  const { data: vendorsData, isFetching } =
    useFetchVendorsQuery(token(), { refetchOnMountOrArgChange: true }) || {};

  const clients = useMemo(() => {
    const vendors = (vendorsData?.body || []).filter((v) => v.tenant_id || v.tenant_id === 0);
    const q = search.trim().toLowerCase();
    const filtered = !q
      ? vendors
      : vendors.filter(
          (v) =>
            (v.name || "").toLowerCase().includes(q) ||
            String(v.tenant_id).includes(q) ||
            (v.theme_name || "").toLowerCase().includes(q),
        );
    return [...filtered].sort((a, b) => (a.name || "").localeCompare(b.name || ""));
  }, [vendorsData, search]);

  return (
    <Page>
      <PageHeader
        title="Tenant Sidebar Setup"
        subtitle="Pick a client to configure which sidebar sections and items are visible in their panel."
      />

      <SearchInput
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        placeholder="Search clients by name, ID or theme…"
        className="mb-3"
      />

      <Table>
        <THead>
          <tr>
            <Th className="w-12">#</Th>
            <Th>Client</Th>
            <Th>Theme</Th>
            <Th>Email</Th>
            <Th className="whitespace-nowrap">Created</Th>
            <th className="px-4 py-2.5 w-32" />
          </tr>
        </THead>
        <tbody>
          {isFetching && clients.length === 0 && <EmptyRow colSpan={6}>Loading clients…</EmptyRow>}
          {!isFetching && clients.length === 0 && <EmptyRow colSpan={6}>No clients found.</EmptyRow>}

          {clients.map((v, i) => (
            <tr
              key={v.tenant_id}
              onClick={() => setEditor({ tenant_id: v.tenant_id, tenant_name: v.name })}
              className="border-t border-gray-100 cursor-pointer hover:bg-gray-50/70 transition-colors"
            >
              <Td className="text-gray-400 text-xs">{i + 1}</Td>
              <Td>
                <span className="font-semibold text-gray-900">{v.name}</span>
                <span className="ml-2 text-xs font-normal text-gray-400">ID: {v.tenant_id}</span>
              </Td>
              <Td className="text-gray-600">{v.theme_name || "—"}</Td>
              <Td className="text-gray-600">{v.email || "—"}</Td>
              <Td className="text-gray-500 whitespace-nowrap">
                {v.created_at ? new Date(v.created_at).toLocaleDateString() : "—"}
              </Td>
              <Td className="text-right">
                <Button
                  size="sm"
                  variant="soft"
                  icon={<FiSliders className="h-3.5 w-3.5" />}
                  onClick={(e) => {
                    e.stopPropagation();
                    setEditor({ tenant_id: v.tenant_id, tenant_name: v.name });
                  }}
                >
                  Configure
                </Button>
              </Td>
            </tr>
          ))}
        </tbody>
      </Table>

      {editor && (
        <TenantSidebarEditor
          tenant={editor}
          onClose={() => setEditor(null)}
          onSaved={() => setEditor(null)}
        />
      )}
    </Page>
  );
};

export default AllTenantSidebar;
